document.addEventListener('DOMContentLoaded', function () {
  var blogSection = document.querySelector('[id*="featured_blog"]');
  if (!blogSection) return;

  var wrapper = document.createElement('div');
  wrapper.className = 'blogs-me-toggle-wrapper';
  wrapper.innerHTML = '<button class="blogs-me-toggle-btn">Read about us</button>';

  blogSection.classList.add('blogs-me-collapsible');
  blogSection.parentNode.insertBefore(wrapper, blogSection);

  wrapper.querySelector('button').addEventListener('click', function () {
    blogSection.classList.toggle('is-open');
    this.textContent = blogSection.classList.contains('is-open')
      ? 'Hide'
      : 'Read about us';
  });
});